import { CircleRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { CanvasCirclePicker, CanvasPickerContribution } from "../constants";

import { DefaultCanvasCirclePicker } from "./circle-picker";

let loadCirclePick = !1;

export function bindCircleCanvasPickerContribution(container) {
    loadCirclePick || (loadCirclePick = !0, container.bind(CanvasCirclePicker).toDynamicValue((() => new DefaultCanvasCirclePicker(resolveContainerBinding(container, CircleRender)))).inSingletonScope(), 
    container.bind(CanvasPickerContribution).toService(CanvasCirclePicker));
}
//# sourceMappingURL=circle-module.js.map
